import { useState, useEffect } from 'react'
import { Sidebar, TopBar } from './components'
import { Accordion, Card, Spinner } from 'react-bootstrap'
import axios from 'axios'

const CONTENT_API = 'https://test.api.hellogov.us'

function App() {
  const [departments, setDepartmentList] = useState(null)
  const [locations, setLocationsList] = useState(null);
  const [jobs, setJobsList] = useState(null);
  const [department, setDepartment] = useState(null);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    axios.get(`${CONTENT_API}/departments`).then(({ data }) => {
      setDepartmentList(data)
    })
  }, [])
  useEffect(() => {
    axios.get(`${CONTENT_API}/locations`).then(({ data }) => {
      setLocationsList(data)
    });
  }, []);
  useEffect(() => {
    axios.get(`${CONTENT_API}/jobs`).then(({ data }) => {
      setJobsList(data)
    });
  }, []);

  if (jobs === null || departments === null || locations === null) {
    return (
      <div className="d-flex justify-content-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  let jobList = jobs
  if (department) {
    jobList = jobList.filter(j => j.department.id === department)
  }
  if (location) {
    jobList = jobList.filter(j => j.location.id === location)
  }
  console.log(jobList)
  


  return (
    <div className="container">
      <div className="row g-3 g-sm-5">
        <div className="col-12 col-sm-4">
          <Sidebar items={departments} onItemClick={setDepartment} activeItem={department} />
        </div>
        <div className="col-12 col-sm-8">
          <div className="row g-3 g-sm-5 align-items-center">
            <div className="col-7 col-sm-8">
              <TopBar options={locations} handleChange={setLocation} value={location} />
            </div>
            <div className="col-5 col-sm-4">
              <h5 className="mb-0 text-center">{`${jobList.map(v => v.total).reduce((a, c) => (a + c), 0)} Jobs Found`}</h5>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <Accordion className="faq--accordian">
                {jobList.map((v, k) => {
                  return (
                    <Card className="mb-2 p-3">
                      <a target='_blank' rel="noreferrer" href={`https://www.hellogov.us/jobs/${v.id}-${v.title.replaceAll(' ', '_')}`}>
                        {`${v.title} (${v.total} openings)`}
                      </a>
                    </Card>
                  )
                })}
              </Accordion>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
}

export default App;
